import { render } from "./AtencionesPorTipo.vue?vue&type=template&id=1b721c7f&scoped=true"
import script from "./AtencionesPorTipo.vue?vue&type=script&lang=js"
export * from "./AtencionesPorTipo.vue?vue&type=script&lang=js"

import "./AtencionesPorTipo.vue?vue&type=style&index=0&id=1b721c7f&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b721c7f"]])

export default __exports__